import * as FC from "@fluentui/react-components";
import * as IC from "@fluentui/react-icons";
import { useCommonStyles } from "../../../style_util";
import { SimpleGrid, useSimpleGrid } from "../../../components/simple_grid";
import { useDrawer } from "../../../components/use_drawer";
import { bindInputValue, useInfo } from "../../../form_utils";
import { DeleteButton } from "../../../components/delete_button";
import { useContext } from "react";
import { Context } from "../../../context";
import { apiClient } from "../../../services/api";
import { describeWriteError } from "../../../services/write_errors";
import { ManuLeafDef, listManuLeaf } from "../../../services/manu_leaf_service";
import { getCurrentFieldId, getCurrentFieldIdFromNew } from "../../../workspace";

const ManuLeafForm = ({ item, onChange }) => {
    const { user } = useContext(Context);
    const { info, setInfo } = useInfo();
    const v = bindInputValue(item, info, setInfo);
    // See manu_turbine.js: without ?tenantId= these writes can only ever return 400.
    const tenantId = user?.tenantId;

    const onDelete = async () => {
        try {
            await apiClient.deleteManuLeaf(item.id, tenantId);
            onChange();
        } catch (error) {
            console.error("Failed to delete leaf manufacturer:", error);
            alert("删除失败: " + describeWriteError(error));
        }
    };
    const onSave = async () => {
        try {
        if (item) {
            await apiClient.updateManuLeaf(item.id, info, tenantId);
            onChange();
        } else {
            const fieldId = getCurrentFieldIdFromNew() || getCurrentFieldId();
            // Extract numeric ID from SurrealDB record format (e.g., "field_item:2" -> 2)
            const numericFieldId = typeof fieldId === 'string' && fieldId.includes(':') 
                ? parseInt(fieldId.split(':')[1]) 
                : fieldId;
            let _info = { 
                Name: info.name || '',
                FieldItemId: numericFieldId
            };
            console.log('Creating manu_leaf with data:', _info);
            await apiClient.createManuLeaf(_info, tenantId);
            onChange();
        }
        } catch (error) {
            console.error("Failed to save leaf manufacturer:", error);
            alert("保存失败: " + describeWriteError(error));
        }
    };

    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.form}>
            <FC.Field label={"厂商名称"}>
                <FC.Input {...v("name")} />
            </FC.Field>

            <FC.Divider />
            {item && <DeleteButton onClick={onDelete} />}
            <FC.Button onClick={onSave} disabled={!info} appearance="primary">
                {(item && "保存") || "创建"}
            </FC.Button>
        </div>
    );
};
export const ManuLeafManagement = () => {
    const { openDrawer, closeDrawer, drawer } = useDrawer();

    const { items, refresh, SearchInput } = useSimpleGrid({
        listItems: listManuLeaf,
        placeholder: "按厂商名称搜索...",
    });

    const onFormChange = () => {
        refresh();
        closeDrawer();
    };
    const onNewManuLeaf = () => {
        openDrawer({
            header: "创建叶片厂商",
            body: <ManuLeafForm item={null} onChange={onFormChange} />,
        });
    };
    const columns = [
        ManuLeafDef.createTableColumn("name"),
        ManuLeafDef.createOpsColumn({
            renderCell: (item) => {
                const onClick = () => {
                    openDrawer({
                        header: "叶片厂商详情",
                        body: (
                            <ManuLeafForm item={item} onChange={onFormChange} />
                        ),
                    });
                };
                return (
                    <FC.TableCellLayout>
                        <FC.Button
                            appearance="subtle"
                            icon={<IC.MoreCircleFilled />}
                            onClick={onClick}
                        />
                    </FC.TableCellLayout>
                );
            },
        }),
    ];
    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.root}>
            <div className={commonStyles.row}>
                <FC.Label>快速检索</FC.Label>
                <SearchInput />
                <FC.Button appearance="primary" onClick={onNewManuLeaf}>
                    创建叶片厂商
                </FC.Button>
            </div>
            <SimpleGrid items={items} columns={columns} />
            {drawer}
        </div>
    );
};
